/** Reports > Stock: the plants' stock pivots as one list (user, 2026-10-23). */
import { reportPermissionsOf } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { StockReportsIndexPage } from "@/features/reports/stock/stock-reports-pages";

export const Route = createFileRoute("/_app/reports/stock/")({
  // Any Stock report's own code opens the list.
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!reportPermissionsOf("stock").some((c) => can(c)))
      throw redirect({ to: "/reports" });
  },
  component: StockReportsIndexPage,
});
